export enum UserOrganisationStatusEnum {
  UNKNOWN = "unknown",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
